<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { DropdownMenuItemProps } from 'reka-ui';
  import { DropdownMenuItem, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<
      DropdownMenuItemProps & {
        class?: HTMLAttributes['class'];
        inset?: boolean;
        variant?: 'default' | 'destructive';
        icon?: boolean | 'left' | 'right';
        noSelect?: boolean;
      }
    >(),
    {
      variant: 'default',
    },
  );

  const delegatedProps = reactiveOmit(props, 'inset', 'variant', 'class');

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuItem
    data-slot="dropdown-menu-item"
    :data-inset="inset ? '' : undefined"
    :data-variant="variant"
    v-bind="forwardedProps"
    :class="
      cn(
        'data-[variant=destructive]:text-destructive font-medium data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*=\'text-\'])]:text-muted-foreground relative flex items-center gap-2 rounded-sm p-2 text-xs outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=\'size-\'])]:size-4',
        !noSelect && 'hover:bg-accent focus:bg-accent focus:text-accent-foreground',
        icon && 'flex items-center w-full [&>i]:w-4 [&>i]:text-2xs',
        icon === true || icon === 'right'
          ? 'justify-between [&>i]:text-right'
          : '[&>i]:text-center',
        props.class,
      )
    "
  >
    <slot />
  </DropdownMenuItem>
</template>

<style scoped lang="postcss"></style>
